// Public routes
export const HOME_ROUTE = '/';
export const LOGIN_ROUTE = '/account/login';
export const SIGN_UP_ROUTE = '/account/create-account';

// Authenticated routes
export const DASHBOARD_ROUTE = '/dashboard';
